import React, {ComponentType, Suspense} from "react";

const NS = 'BookingCreatorContainer';

export default function BookingCreatorContainer() {
  const BookingCreatorSlide = React.lazy(() =>
    import('./BookingCreatorSlide')
  );
  const PaymentLinkInfoSlide: any = React.lazy(
    () => import("./PaymentLinkInfoSlide")
  );
  return <Suspense fallback={<div>Loading...</div>}>
    <BookingCreatorSlide />
    <PaymentLinkInfoSlide />
  </Suspense>
}
